export const SET_COMPONENTS = 'SET_COMPONENTS'
export const SET_COMPONENT = 'SET_COMPONENT'
export const SET_COMPONENT_DATA = 'SET_COMPONENT_DATA'
export const RESET_COMPONENT = 'RESET_COMPONENT'
export const SET_DASHBOARDNAME = 'SET_DASHBOARDNAME'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_PAGER = 'SET_PAGER'
export const SET_MEDIA = 'SET_MEDIA'
export const SET_MEDIA_ITEM = 'SET_MEDIA_ITEM'
export const SET_MEDIA_DATA = 'SET_MEDIA_DATA'
export const RESET_COMPONENTS = 'RESET_COMPONENTS'
export const RESET_MEDIA = 'RESET_MEDIA'
export const RESET_MEDIA_ITEM = 'RESET_MEDIA_ITEM'
export const SET_MEMBER_STATUS = 'SET_MEMBER_STATUS'

export const STORE_PAGER = 'components/pager'
